import React, { useEffect, useState } from "react";
import MainBg from "../../components/Mainbg";
import Banner3 from "../../assets/images/dasboard/banner3.png";
import Drawer from "react-modern-drawer";
import GymView from "../Sidebar/GymView";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import {
  GET_GYM_EXPLORE_ENDPOINT,
  GET_GYM_TARGETED_ENDPOINT,
} from "../../config/ApisCollection";
import { useNavigate, useParams } from "react-router-dom";
import gymloader from "../../assets/images/loaders/gymloader.png";

const GYM = () => {
  const [isDrawerPopupOpen, setDrawerPopupOpen] = useState(false);
  const [workoutChoosedData, setWorkoutChoosedData] = useState(null);
  const [workout_data, set_workout_data] = useState([]);
  const accessToken = secureLocalStorage.getItem("accessToken");
  const { type, category } = useParams();
  let history = useNavigate();

  const getGoodReadData = async () => {
    const currentDate = new Date();
    let api_url = `${GET_GYM_TARGETED_ENDPOINT}/${category}`;
    if (category === "workoutexplore") {
      api_url = `${GET_GYM_EXPLORE_ENDPOINT}`;
    }
    const post_header = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    };
    try {
      await axios.post(api_url, {}, post_header).then((response) => {
        setTimeout(() => {
          set_workout_data(Object.entries(response.data));
        }, 2000);
      });
    } catch (error) {}
  };

  const getExploreData = async () => {
    const currentDate = new Date();
    let api_url = `${GET_GYM_TARGETED_ENDPOINT}/${category}`;
    if (category === "workoutexplore") {
      api_url = `${GET_GYM_EXPLORE_ENDPOINT}`;
    }
    const post_header = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    };
    try {
      await axios.get(api_url, post_header).then((response) => {
        setTimeout(() => {
          set_workout_data(Object.entries(response.data));
        }, 2000);
      });
    } catch (error) {}
  };

  useEffect(() => {
    if (category === "workoutexplore") {
      getExploreData();
    } else {
      getGoodReadData();
    }
    window.scrollTo(0, 0);
  }, []);
  // console.log(workout_data);

  return (
    <>
      <MainBg>
        <div className="grid xl:grid-cols-3 md:grid-cols-1 sm:grid-cols-1  grid-cols-1 sm:gap-2  mb-20 ">
          <div className="col-span-2  sm:border-r-2 border-none xl:order-1 order-2">
            {/* <div className="">
              <input
                type="text"
                className="w-full border-2 border-gray-350 p-2 rounded-lg"
                placeholder="↻ Search workouts..."
              />
            </div> */}

            {workout_data?.length == 0 && (
              <>
                <img src={gymloader} className="h-72 m-auto" />
                <h1 className="text-center mt-10">loading....</h1>
              </>
            )}

            {category === "workoutexplore" ? (
              <div>
                {workout_data.length > 0 &&
                  workout_data[4][1]?.map((cl_row, index) => (
                    <div key={index} className="mt-10">
                      <div className="mt-2">
                        <h1 className="font-bold">
                          {typeof cl_row.title === "string"
                            ? cl_row.title?.toUpperCase()
                            : ""}
                        </h1>
                      </div>
                      <div className="mt-2 grid xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-5">
                        {typeof cl_row.data === "object" &&
                          cl_row.data.map((wl_row, index) =>
                            wl_row.name === wl_row.name ? (
                              <div
                                className="melasbox  cursor-pointer hover:bg-[#ffede0]"
                                onClick={() => {
                                  // setDrawerPopupOpen(true);
                                  // setWorkoutChoosedData(wl_row);
                                  history("/gym/gym-view", {
                                    state: wl_row,
                                  });
                                }}
                                key={index}
                              >
                                <div>
                                  <img
                                    loading="lazy"
                                    src={wl_row.imageUrl}
                                    alt="meals1"
                                    className="mealsimg h-[121px]"
                                  />
                                </div>
                                <div className="melalin">
                                  <div className="modesutit text-capitalize">
                                    {wl_row.duration} min
                                  </div>
                                  <div className="tabetsbol text-capitalize text-[10px]">
                                    {wl_row.name.slice(0, 20)}
                                  </div>
                                  <hr />
                                  <div className="fastiweekboxtit">
                                    {wl_row.repetition + " routines"}{" "}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <span key={index}></span>
                            )
                          )}
                      </div>
                    </div>
                  ))}
              </div>
            ) : (
              <div>
                {workout_data.length > 0 &&
                  workout_data[1]?.map((cl_row, index) => (
                    <div key={index}>
                      <div className="mt-2">
                        <h1 className="font-bold">
                          {typeof cl_row === "string"
                            ? workout_data[0][1].toUpperCase()
                            : ""}
                        </h1>
                      </div>
                      {cl_row.length > 0 ? (
                        <div className="mt-2 grid xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-5 ">
                          {typeof cl_row === "object" &&
                            cl_row.map((wl_row, index) =>
                              wl_row.name === wl_row.name ? (
                                <div
                                  className="melasbox  cursor-pointer hover:bg-[#ffede0]"
                                  onClick={() => {
                                    history("/gym/gym-view", {
                                      state: wl_row,
                                    });
                                  }}
                                  key={index}
                                >
                                  <div>
                                    <img
                                      loading="lazy"
                                      src={wl_row.imageUrl}
                                      alt={wl_row?.name?.slice(0, 20)}
                                      className="mealsimg h-[121px]"
                                    />
                                  </div>
                                  <div className="melalin">
                                    <div className="modesutit text-capitalize">
                                      {wl_row.duration} min
                                    </div>
                                    <div className="tabetsbol text-capitalize text-[10px]">
                                      {wl_row?.name?.slice(0, 20)}
                                    </div>
                                    <hr />
                                    <div className="fastiweekboxtit">
                                      {wl_row.repetition + " routines"}{" "}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <span key={index}></span>
                              )
                            )}
                        </div>
                      ) : (
                        <p className="text-center">Videos not found...</p>
                      )}
                    </div>
                  ))}
              </div>
            )}
          </div>
          <div className="flex sm:flex-row flex-col xl:justify-center relative sm:right-0 px-1 mt-10 xl:order-2 order-1">
            <div className="">
              <div
                className="cardbox sm:w-full w-full bg-cover bg-center px-0 "
                style={{ backgroundImage: "url('/images/bannerActive.png')" }}
              >
                <div className="mode1 ">
                  <img className="watchImg" alt="watchImg" src={Banner3} />
                  <div className="py-2">
                    <p className="cardboxtitle text-base">
                      Healthy life belongs to everyone
                    </p>
                    <p className="text-xs">
                      Get workouts tailored to your needs and preferences.
                    </p>
                    <button
                      className="mt-2 light-orgn-btn rounded-lg text-[11px]"
                      onClick={() => {
                        window.location.href = "/gym/explore/workoutexplore";
                      }}
                    >
                      Explore workouts
                    </button>
                  </div>
                </div>
              </div>

              {workout_data.length > 0 && workout_data[3] ? (
                <>
                  <div className="sm:w-3/4 w-full mt-10">
                    <div className="fasweekdes">
                      <div className="mode1">
                        <div className="tabroe">
                          <div className="modetit text-lg">
                            Targeted workout
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="fasweekdes">
                      {workout_data.length > 0 &&
                        workout_data[3] &&
                        workout_data[3][1].map((tp_row, index) =>
                          index < 4 ? (
                            <div
                              className="melasbox cursor-pointer"
                              key={index}
                              onClick={() => {
                                window.location.href =
                                  "/gym/explore/" + tp_row.categoryvalue;
                              }}
                            >
                              <div className="relative">
                                <img
                                  loading="lazy"
                                  src={tp_row.image}
                                  alt="meals1"
                                  className="h-[70px] w-[70px]"
                                />
                                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[10px] text-center text-white">
                                  {tp_row.categoryvalue.toUpperCase()}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <></>
                          )
                        )}
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}

              {/* <div className="fastiweekbox sm:w-3/4 w-full">
                <div className="fastiweekboxtit text-sm font-semibold">
                  Your workout streak
                </div>

                <div className="fasweekdes mb-5">
                  {workout_data.length > 0 &&
                    workout_data[5][1].track.map((fs_row, index) => (
                      <div className="tabroe" key={index}>
                        <img
                          loading="lazy"
                          src={fs_row.img}
                          alt="fireac"
                          className="w-6"
                        />
                        <div className="fastiweekboxtext text-xs mt-1 font-medium">
                          {fs_row.day.slice(0, 3)}
                        </div>
                      </div>
                    ))}
                </div>

                <div className="text-xs font-medium text-center">
                  <span className="">You’re </span>
                  <span className="text-[#fe7701]"> 40% more likely</span>
                  <span className=""> to achieve your goal</span>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </MainBg>

      <Drawer
        open={isDrawerPopupOpen}
        direction="right"
        lockBackgroundScroll={false}
        className={`manlay !p-5 !pb-10 sm:!w-96 !w-80 !overflow-y-scroll !overflow-x-hidden !rounded-l-3xl !border-none`}
        onClose={() => {
          setDrawerPopupOpen(false);
        }}
      >
        <GymView workoutChoosedData={workoutChoosedData} />
      </Drawer>
    </>
  );
};
export default GYM;
